// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1nVnP","noInteraction":"EventWrapper_noInteraction__3O0Ao"};